import { render, staticRenderFns } from "./view-article.html?vue&type=template&id=3c4d6f67&scoped=true&external"
import script from "./view-article.js?vue&type=script&lang=js&external"
export * from "./view-article.js?vue&type=script&lang=js&external"
import style0 from "./view-article.scss?vue&type=style&index=0&id=3c4d6f67&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4d6f67",
  null
  
)

export default component.exports